export default __webpack_public_path__ + "static/blob6-726a95ae71c7185d6c1bd47fb2162331.svg";